import { activeSpaceReducer } from './toolkits/space/slice';
import { appReducer } from './toolkits/app/slice';
import { authReducer } from './toolkits/auth/slice';
import { calendarReducer } from './toolkits/calendar/slice';
import { uiReducer } from './toolkits/ui/slice';
import { currentModuleReducer } from './toolkits/currentModule/slice';
import { deviceModuleReducer } from './toolkits/devices/slice';
import { kbarReducer } from './toolkits/kbar/slice';
import { notificationsReducer } from './toolkits/notification/slice';
import { pageTitleReducer } from './toolkits/pageTitle/slice';
import { versionReducer } from './toolkits/version/slice';

export const reducer = {
  notifications: notificationsReducer,
  kbar: kbarReducer,
  pageTitle: pageTitleReducer,
  ui: uiReducer,
  activeSpace: activeSpaceReducer,
  auth: authReducer,
  app: appReducer,
  currentModule: currentModuleReducer,
  devices: deviceModuleReducer,
  calendar: calendarReducer,
  versions: versionReducer,
};
